import axios from 'axios'
import '../controllers'

App.Request = axios.create({
  headers: {
    'X-CSRF-Token':
      App.State.appEnvironment === 'test' ? '' : App.State.csrfToken,
    'X-Requested-With': 'XMLHttpRequest',
  },
})

App.GAEvent = (eventCategory, eventAction, eventLabel, eventValue) => {
  if (typeof window.ga === 'undefined') return

  window.ga('send', {
    hitType: 'event',
    eventAction,
    eventCategory,
    eventLabel,
    eventValue,
    userId: App.State.userId,
  })
}

// All supported browsers handle WebP, so set this statically instead of
// probing at runtime. The old probe ran a fetch + createImageBitmap on every
// page load (main-thread work) and, because supportsWebp() returned a Promise,
// always resolved truthy anyway — so this preserves behavior.
App.State.supportsWebp = true

window.addEventListener('load', () => {
  const gaElements = document.querySelectorAll('.ga-event')

  if (gaElements.length > 0) {
    gaElements.forEach((gaElement) => {
      gaElement.addEventListener('click', (e) => {
        const gaData = JSON.parse(e.currentTarget.getAttribute('data-ga-event'))

        if (App.State.appEnvironment !== 'production') {
          // eslint-disable-next-line no-console
          console.log(gaData)
        }

        App.GAEvent(gaData.category, gaData.action, gaData.label, gaData.value)
      })
    })
  }
})
